import { Component, OnInit } from '@angular/core';
import { ConfigCheckerAuthService } from '../../services/config-checker-auth.service';
import { LoginUserDto } from '../../models/login-user-dto';
import { CheckerDataService } from '../../services/checker-data.service';

@Component({
  selector: 'app-config-checker-auth',
  templateUrl: './config-checker-auth.component.html',
  styleUrls: ['./config-checker-auth.component.scss']
})
export class ConfigCheckerAuthComponent implements OnInit {
  credentials: LoginUserDto = {
    username: '',
    password: ''
  };
  error: string | null = null;
  isLoading = false;

  constructor(public authService: ConfigCheckerAuthService, private checkerDataService: CheckerDataService) {}

  ngOnInit() {}

  login() {
    this.isLoading = true;
    this.error = null;
    this.authService.login(this.credentials).subscribe({
      next: () => {
        this.isLoading = false;
      },
      error: (err) => {
        this.isLoading = false;
        this.error = 'Login failed. Please check your credentials.';
        console.error('Login error', err);
      }
    });
  }

  logout() {
    this.authService.logout().subscribe({
      next: () => {
        this.checkerDataService.isCheckerActive = false;
        console.log('Logged out');
      },
      error: (err) => {
        console.error('Logout error', err);
      }
    });
  }
}
